export const START_SEARCH_KEYWORDS = 'START_SEARCH_KEYWORDS';

export const SET_SEARCH_KEYWORDS = 'SET_SEARCH_KEYWORDS';

export const SEARCH_KEYWORDS_ERROR = 'SEARCH_KEYWORDS_ERROR';

export const CHANGE_INPUT = 'CHANGE_INPUT';

export const ADD_KEYWORD = 'ADD_KEYWORD';

export const REMOVE_KEYWORD = 'REMOVE_KEYWORD';

export const SET_KEYWORDS = 'SET_KEYWORDS';

export const UNSET_KEYWORDS = 'UNSET_KEYWORDS';
